import { localizationService } from '@shared-services/localization-service';
import { useContext, useMemo } from 'react';
import { useBookingContext } from '../Context';
import strings from '../strings';
import { shouldUsePaidBooking } from '../utils';
import useBookerLabels from './useBookerLabels';
import { BookerStateContext } from './useRuntimeCalBookingState';

const str = localizationService.str;

// Here we are overriding default labels with custom
const useBookerCustomLabel = (language: string) => {
    const { labels: defaultLabels, labelsLoaded } = useBookerLabels(language);
    const bookerContext = useBookingContext();
    const [bookingState] = useContext(BookerStateContext);

    const mergedLabels = useMemo(() => {
        const requiresBookerEmailVerification =
            bookingState.calEventData?.requiresBookerEmailVerification;
        const isPaidBooking = shouldUsePaidBooking(bookerContext);
        const isRegularFlow = !bookingState.rescheduleUid;

        if (
            isPaidBooking &&
            isRegularFlow &&
            !requiresBookerEmailVerification
        ) {
            return {
                ...defaultLabels,
                confirm: str(strings.paidBookingNextStepButton),
            };
        }

        return defaultLabels;
    }, [
        defaultLabels,
        bookerContext,
        bookingState.rescheduleUid,
        bookingState.calEventData,
    ]);

    return { labels: mergedLabels, labelsLoaded };
};

export default useBookerCustomLabel;
